import React from 'react';

import CellContent from './CellContent';

import { CellDecorator } from '../../../Enum/TableDecorator';
import { Cell as ICell } from '../../../Interface/Hook/Interest/InterestTableDTO';
import { Interest } from '../../../Interface/Response/Interest/Interest';

import { convertCamelCaseToKebabCase } from '../../../Helpers/String';

interface Props {
    cell: ICell;
}

const Cell: React.FC<Props> = ({ cell: { decorator, value, appendix } }: Props) => {
    const getClassName = (): string | undefined => {
        if (!decorator
            || (decorator !== CellDecorator.Interest && decorator !== CellDecorator.CompanyIcon)
        ) {
            return undefined;
        }

        if (decorator !== CellDecorator.Interest) {
            return convertCamelCaseToKebabCase(decorator);
        }

        if (!(value as Interest).onlyForExistingCustomers) {
            return undefined;
        }

        return convertCamelCaseToKebabCase(CellDecorator.Strikethrough);
    };

    return (
        <td className={getClassName()}>
            <CellContent decorator={decorator}
                         value={value}
                         appendix={appendix}
            />
        </td>
    );
};

export default Cell;
